// convertFormdata.js
function convertFormdataByType(type, oldValue) {
    let covertedValue = '';
    if (type === "Imperial") {
      // Convert from Celsius to Fahrenheit
        covertedValue = Math.round((oldValue * 9/5) + 32);
    } else if (type === "SI") {
      // Convert from Fahrenheit to Celsius
        covertedValue = Math.round((oldValue - 32) * 5/9);
    }

      return covertedValue

    }
  
  export default convertFormdataByType;
  